import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    breadcrumbs: {
      display: 'flex',
      alignItems: 'center',
      flexFlow: 'row wrap',
    },
    breadcrumb: {
      cursor: 'pointer',
      margin: '0',
      fontFamily: 'Roboto',
      fontSize: '12px',
      lineHeight: '14px',
      color: '#2C2D3E',
      '&:last-child': {
        fontWeight: 'bold',
        color: '#3C419A',
      },
      maxWidth: '120px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    breadcrumbSeparator: {
      color: '#2C2D3E',
      margin: '0 5px',
    },

    dropdown: {
      cursor: 'pointer',
      borderRadius: '5px',
      border: '1px solid rgba(44, 45, 62, 0.3)',
      marginRight: '10px',
      width: '34px',
      height: '18px',
      fill: 'rgba(60, 65, 154, 0.6)',
    },
  }),
);
